import { useState } from "react";

import cn from "classnames";

// import child components
import UtilityMenu from "./UtilityMenu/Desktop.jsx";
import TopNav from "./TopNav.jsx";
import MobilePanel from "./MobilePanel.jsx";
import SearchModal from "./Search/SearchModal.jsx";
import HeaderIcons from "./HeaderIcons.jsx";

// import LDS components
import LdsLillyLogo from "../LdsLillyLogo/index.jsx";

export default function LdsHeader({
  // PRIMARY MENU
  topNavAriaLabel = "Primary",
  children,
  // Utility MENU
  showUtilityLogo = true,
  utilityMenuLinks = [],
  utilityMenuAriaLabel = "Global",
  utilityMenuCustomLinkItems,
  utilityMenuCustomLinkItemsPosition = "after",
  contactLilly = null,
  languageSelector = null,
  // LOGO
  lillyLogo = {
    size: "md",
    className: "pd-0",
  },
  customLogo = undefined,
  // TEXT LABELS
  labelMenu = "Menu",
  labelMobileMenuOpened = "menu opened",
  labelMobileMenuClosed = "menu closed",
  labelCloseMenu = "Close",
  // SEARCH
  search = false,
  searchTerm,
  setSearchTerm,
  searchSuggestions,
  searchCustomResult,
  searchInputPlaceholder,
  searchBtnLabel,
  searchNoResultsText,
  searchAnotherSearchText,
  searchLoading,
  searchClearBtnAriaLabel,
  searchMobileBtnAriaLabel,
  searchMobileCloseAriaLabel,
  searchMobileCloseLabel,
  searchOnBtnClick,
  searchOnSuggestionClick,
  searchSubmitBtnAriaLabel,
  searchInputAriaDescription,
  searchOpenedAnnouncement = "Search open",
  searchClosedAnnouncement = "Search closed",
  searchInputAriaLabel,
  // UTILITIES
  sticky = false,
  className = "",
  ...rest
}) {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const showUtilityMenu =
    !!contactLilly ||
    !!languageSelector ||
    (utilityMenuLinks &&
      Array.isArray(utilityMenuLinks) &&
      utilityMenuLinks.length > 0);

  function toggleMobileMenu() {
    if (isMobileMenuOpen) {
      setIsMobileMenuOpen(false);
      // If the menu is open, we focus the open menu button after closing it.
      // if (openMenuButtonRef.current) {
      //   openMenuButtonRef.current.focus();
      // }
    } else {
      setIsMobileMenuOpen(true);
      // If the menu is closed, we focus the close menu button after opening it.
      // if (closeMenuButtonRef.current) {
      //   closeMenuButtonRef.current.focus();
      // }
    }
  }

  return (
    <div
      className="lds-header-wrapper"
      style={{ position: sticky ? "sticky" : "relative", top: 0 }}
    >
      <header
        id="header"
        className={cn("lds-header", className)}
        style={{ position: sticky ? "sticky" : "relative" }}
        {...rest}
      >
        <span
          id="a11y-state-announcer"
          role="status"
          className="visually-hidden"
        ></span>

        <div className="lds-header-main">
          {/* HEADER BAR */}
          <div className="lds-header-logo-wrapper">
            {customLogo || <LdsLillyLogo {...lillyLogo} />}

            <HeaderIcons
              labelMenu={labelMenu}
              labelMobileMenuClosed={labelMobileMenuClosed}
              labelMobileMenuOpened={labelMobileMenuOpened}
              toggleMobileMenu={toggleMobileMenu}
              isMobileMenuOpen={isMobileMenuOpen}
              searchMobileBtnAriaLabel={searchMobileBtnAriaLabel}
              searchMobileCloseAriaLabel={searchMobileCloseAriaLabel}
              searchMobileCloseLabel={searchMobileCloseLabel}
              searchOpenedAnnouncement={searchOpenedAnnouncement}
              searchClosedAnnouncement={searchClosedAnnouncement}
            />
          </div>

          <div className="header-menus-container flex-1">
            {showUtilityMenu && (
              <UtilityMenu
                showUtilityLogo={showUtilityLogo}
                languageSelector={languageSelector}
                utilityMenuLinks={utilityMenuLinks}
                utilityMenuAriaLabel={utilityMenuAriaLabel}
                customLinkItems={utilityMenuCustomLinkItems}
                customLinkItemsPosition={utilityMenuCustomLinkItemsPosition}
                contactLilly={contactLilly}
                search={search}
                searchBtnLabel={searchBtnLabel}
              />
            )}

            <TopNav topNavAriaLabel={topNavAriaLabel}>{children}</TopNav>

            <MobilePanel
              // Utility menu
              showUtilityMenu={showUtilityMenu}
              showUtilityLogo={showUtilityLogo}
              contactLilly={contactLilly}
              languageSelector={languageSelector}
              utilityMenuLinks={utilityMenuLinks}
              utilityMenuAriaLabel={utilityMenuAriaLabel}
              utilityMenuCustomLinkItems={utilityMenuCustomLinkItems}
              utilityMenuCustomLinkItemsPosition={
                utilityMenuCustomLinkItemsPosition
              }
              // Mobile top header bar props
              customLogo={customLogo}
              lillyLogo={lillyLogo}
              labelCloseMenu={labelCloseMenu}
              //
              topNavAriaLabel={topNavAriaLabel}
              toggleMobileMenu={toggleMobileMenu}
              isMobileMenuOpen={isMobileMenuOpen}
            >
              {children}
            </MobilePanel>
          </div>
        </div>
      </header>

      {/*
        Search modal needs to live in the top level of the header. Deeply nesting this can cause re-rendering issues
       */}
      <SearchModal
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
        searchSuggestions={searchSuggestions}
        searchCustomResult={searchCustomResult}
        searchInputPlaceholder={searchInputPlaceholder}
        searchNoResultsText={searchNoResultsText}
        searchAnotherSearchText={searchAnotherSearchText}
        searchLoading={searchLoading}
        searchClearBtnAriaLabel={searchClearBtnAriaLabel}
        searchOnBtnClick={searchOnBtnClick}
        searchOnSuggestionClick={searchOnSuggestionClick}
        searchSubmitBtnAriaLabel={searchSubmitBtnAriaLabel}
        searchInputAriaDescription={searchInputAriaDescription}
        searchInputAriaLabel={searchInputAriaLabel}
      />
    </div>
  );
}
